<template>
  <div class="single-article">
    <single-press-release :pressReleaseId="$route.params.id">
      <template slot-scope="props">
        <article class="article main-article" v-if="props.pressRelease">
          <header>
            <h1>{{ props.pressRelease.titre }}</h1>
            <ul class="details">
              <li>{{ props.pressRelease.date }}</li>
            </ul>
          </header>
          <div class="main">
            <div v-html="props.pressRelease.body_html"></div>
          </div>
        </article>
        <div class="sharing">
          <div class="title"><i class="ion-android-share-alt"></i> Partage</div>
          <ul class="social">
            <li>
              <a href="https://www.facebook.com/sharer/sharer.php" class="facebook" target="_blank">
                <i class="ion-social-facebook"></i> Facebook
              </a>
            </li>
            <li>
              <a :href="`https://twitter.com/home?status=${pageUrl}`" class="twitter" target="_blank">
                <i class="ion-social-twitter"></i> Twitter
              </a>
            </li>
            <li>
              <a :href="`https://plus.google.com/share?url=${pageUrl}`" class="googleplus" target="_blank">
                <i class="ion-social-googleplus"></i> Google+
              </a>
            </li>
            <li>
              <a :href="`https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`" class="linkedin" target="_blank">
                <i class="ion-social-linkedin"></i> Linkedin
              </a>
            </li>
          </ul>
        </div>
      </template>
    </single-press-release>
    <h4>Commentaires</h4>
    <comments :id="`press-${$route.params.id}`"></comments>
  </div>
</template>


<script>
  import { SinglePressRelease, Comments } from 'itrnews-vuejs-api';

  export default {
    name: 'PressReleasePage',
    components: { SinglePressRelease, Comments },
    mounted() {
      this.pageUrl = window.location.href;
    },
    data() {
      return {
        pageUrl: '',
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/PressReleasePage.vue